import React from 'react';
import PropTypes from 'prop-types';

import Slider from '../../Util/Slider/SliderView';

// import assets
import './teaserModule.scss';


const TeaserModuleView = (props) => {
  const sliderSettings = {
    accessibility: true,
    variableWidth: false,
    centerMode: false,
    infinite: false,
    vertical: false,
    initialSlide: 0,
    centerPadding: '0px',
    arrows: true,
    adaptiveHeight: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const slidesToShow = props.slidesToShow;

  const headline = props.headline !== '' ? (<div className={'m-teaser-module__headline'}><p>{props.headline}</p></div>) : null;

  if (props.tiles.length > 0) {
    if (slidesToShow > 0) {
      return (
        <div className="m-article-module">
          {headline}
          <div className="m-teaser-module">
            <Slider sliderSettings={{ ...sliderSettings, slidesToShow }}>
              {props.tiles}
            </Slider>
          </div>
        </div>
      );
    }

    return (
      <div className="m-article-module">
        {headline}
        <div className="m-teaser-module">
          {props.tiles}
        </div>
      </div>
    );
  }
  return null;
};

TeaserModuleView.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.node),
  headline: PropTypes.string,
  slidesToShow: PropTypes.number,
};

TeaserModuleView.defaultProps = {
  tiles: [],
  headline: '',
  slidesToShow: 0,
};

export default TeaserModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/TeaserModule/TeaserModuleView.jsx